import React, { useState } from 'react'
import SaveIcon from './save-icon.svg'
import DownloadIcon from './download-icon.svg'
import { WSSearch } from './wsSearch'
import { PRINTABLE_WORKSHEET_SCREENS, usePrintableWorksheetsState } from 'printableWorksheets/state'
import { WorksheetsEnvironment } from 'printableWorksheets'

const WSTeacherHeader = () => {

    const { activeGrade, subjectCode, worksheetSearchValue, userId, defaultSearch, savedCount, downloadCount, setDefaultSearch, setActiveScreen, worksheetsEnvironment} = usePrintableWorksheetsState();
    const [showHeader, toggleHeader] = useState<boolean>(true);

    const toggleDefaultSearch = (value: boolean) => {
        setDefaultSearch(value);
        value ? toggleHeader(true) : toggleHeader(false);
    }

  return (
    <div className='ws-teacher-header'>
        {showHeader && (
            <div className="ws-teacher-header__left">
                <div data-test-id="saved-worksheets" className="ws-numbered-tag" onClick={() => setActiveScreen(PRINTABLE_WORKSHEET_SCREENS.SAVED)}>
                    <div className="ws-numbered-tag__icon"><SaveIcon /></div>
                    <div className="ws-numbered-tag__label">Saved worksheets</div>
                    <div className="ws-numbered-tag__number">{savedCount}</div>
                </div>
                <div data-test-id="downloaded-history" className="ws-numbered-tag left-margin" onClick={() => setActiveScreen(PRINTABLE_WORKSHEET_SCREENS.DOWNLOADED)}>
                    <div className="ws-numbered-tag__icon"><DownloadIcon /></div>
                    <div className="ws-numbered-tag__label">Download history</div>
                    <div className="ws-numbered-tag__number">{downloadCount}</div>
                </div>
            </div>
        )}
        <div className={`ws-teacher-header__right ${!defaultSearch ? "increase-width" : ""}`}>
            <WSSearch
                defaultSearch={defaultSearch}
                subjectCode = {subjectCode}
                toggleDefaultSearch = {toggleDefaultSearch}
                worksheetSearchValue = {worksheetSearchValue}
                gradeCode={activeGrade}
                userId={userId}
                searchPlaceholder={worksheetsEnvironment == WorksheetsEnvironment.STUDENT_DASHBOARD ? `Search Printables...` : `Search ${subjectCode} worksheets...`}
            />
        </div>
    </div>
  )
}

export default WSTeacherHeader